/**
 * 任务初始化请求参数
 */
export interface TaskInitRequest {
    /**
     * 任务 ID
     */
    task_id: string;
    /**
     * 任务类型
     */
    task_type: string;
    /**
     * 用户输入（专利号）
     */
    user_input: string;
    /**
     * 模型选择，空字符串表示自动选择
     */
    model?: '' | 'deepseek' | 'qwen';
    /**
     * 元数据
     */
    metadata?: Record<string, any>;
}

/**
 * 任务初始化响应
 */
export interface TaskInitResponse {
    /**
     * 请求状态
     */
    status: boolean;
    /**
     * 错误代码
     */
    error_code: number;
    /**
     * 错误消息
     */
    error_msg?: string;
    /**
     * 错误详情
     */
    data?: {
        numeric_error_code: number;
        error_code: string;
        error_message: string;
        message_vars: string[];
        originating_service: string;
        timestamp: string;
    };
}

export const TaskInitApi = Symbol('TaskInitApi');

/**
 * 任务初始化 API
 */
export interface TaskInitApi {
    /**
     * 初始化任务
     */
    initTask(request: TaskInitRequest): Promise<TaskInitResponse>;
}
